// The storage account is private (publicNetworkAccess disabled) and reachable only over its
// private endpoints, so assets are no longer fetched from blob storage directly. They come
// through the /api/assets pass-through on dup-backend, which is VNet integrated.
const assetBaseUrl = (process.env.VUE_APP_ASSET_BASE_URL
  || (process.env.NODE_ENV === 'development'
    ? '/api/assets'
    : 'https://dup-backend.azurewebsites.net/api/assets')).replace(/\/$/, '');

export function assetUrl(path = '') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${assetBaseUrl}${normalizedPath}`;
}

export { assetBaseUrl };
